import PolicyDocumentPage from './PolicyDocumentPage'

const FALLBACK = `
<p>At DigiSutra, we respect your privacy and are committed to protecting your personal data. This policy explains how we collect, use, and safeguard information when you use our website or contact us.</p>
<h2>Information we collect</h2>
<p>When you submit the contact form, we collect your name, email, phone number, company name, and service interest. This information is used only to respond to your enquiry and provide the services you request.</p>
<h2>How we use your data</h2>
<p>We use your data to communicate with you, deliver our services, and improve our offerings. We do not sell or share your personal information with third parties for marketing purposes.</p>
<h2>Contact</h2>
<p>For any privacy-related questions, contact us at info@digisutra.in.</p>
`

export default function PrivacyPage() {
  return <PolicyDocumentPage slug="privacy" fallbackTitle="Privacy Policy" fallbackHtml={FALLBACK} />
}
